import { useState } from "react";

import { AC_STEP_PARENT_WARNING,  AC_STEP_SELF_WARNING, AC_STEP_YOUTH_WARNING} from "../../utils/AccountCreationConstants";

import useAccountCreationData from "../../../../../../state/landingPages/accountCreation/UseAccountCreationData";

import { evaluateBirthDate } from "@usas/ui-web/utils/validation";

const MINIMUM_ACCOUNT_AGE = 16;

const useAccountCreationConfirmAge = () => {
  const { accountCreationState, updateAccountCreationStep } = useAccountCreationData();
  const [displayInvalidAgePopupState, setDisplayInvalidAgePopupState] = useState(false);

  const onBackClicked = () => {
    updateAccountCreationStep(AC_STEP_PARENT_WARNING);
  };

  const onCloseInvalidAgePopupClicked = () => {
    setDisplayInvalidAgePopupState(false);
  };

  const onSubmitFormCallback = (formState) => {
    // Validate birth date and calculate age
    const birthDateEvaluation = evaluateBirthDate(formState.birthDate);
    
    if (birthDateEvaluation?.ageInYears >= MINIMUM_ACCOUNT_AGE) {
      // User is 16 or older, go to self warning step
      updateAccountCreationStep(AC_STEP_SELF_WARNING, formState, 'confirmAgeData');
    } else if (birthDateEvaluation?.ageInYears >= 0) {
      // User is under 16 but valid age, go to youth warning step
      updateAccountCreationStep(AC_STEP_YOUTH_WARNING, formState, 'confirmAgeData');
    } else {
      // Invalid age or birth date, show error popup
      setDisplayInvalidAgePopupState(true);
    }
  };

  return {
    confirmAgeData: accountCreationState?.confirmAgeData || {},
    displayInvalidAgePopupState,
    onBackClicked,
    onCloseInvalidAgePopupClicked,
    onSubmitFormCallback
  };
};

export default useAccountCreationConfirmAge;